/**
 * 此模块入口专门针对有RFQ需求的业务场景. 默认的Alitalk在用户是离线的时候, 点击的操作和在线的相同, 即打
 * 开ATM/WebATM, 此版本支持用户在离线时, 点击alitalk链接会打开feedback窗口, 并进行2416打点
 *
 * @author zoujie.wzj@alibaba-inc.com
 */

    var $ = require('@alife/alpha-jquery/jquery');
    var Alitalk = require('./src/js/alitalk.js');
    var AtmPlugin = require('./src/js/atm-plugin.js');
    var Utils = require('./src/js/utils.js');
    var Domdot = require('@alife/alpha-domdot/domdot');

    function openRFQ(encryptId) {
        var that = this;
        var url;

        if (encryptId) {
            url = Utils.getFeedBackUrlLastest(that.get('from'), that.get('productId'), encryptId, 0);
        } else {
            url = Utils.getFeedBackUrl(that.get('from'), that.get('productId'), 0);
        }
        //允许URL添加额外的search
        var extra = that.get('extra');
        for (var i in extra) {
            if (url.indexOf(i) !== -1) {
                console.warn('the key of extra:' + i + 'is conflict');
            } else {
                url += '&' + i + '=' + extra[i];
            }
        }
        var win = open(url, 'aliFeedBack', 'location=no,toolbar=no,status=no,resizable=yes,scrollbars=yes');
        win.focus();

        // ATM询盘打点
        Domdot.dotstat(2416);
        /*@debug
         console.log('ATM询盘打点:' + 2416);
         */
    }

    exports.renderList = function (elements, config) {
        if (!config) {
            config = {};
        }

        return Alitalk.renderList(elements, $.extend(true, {
            usrData: {
                eid: 'cid_f'
            },
            offlineCallback: function () {
                // 如果非强制询盘, 并且客户端可用, 就走默认的客户端打开流程
                if (!config.forceRfq && AtmPlugin.isReady()) {
                    return false;
                }

                var encryptId = this.get('enProductId');

                openRFQ.call(this, encryptId);

                return true;
            }
        }, config));
    };
